import { render, staticRenderFns } from "./CrosswordAdd.vue?vue&type=template&id=70bfa5fe"
import script from "./CrosswordAdd.vue?vue&type=script&lang=js"
export * from "./CrosswordAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports